import { DataFilterOption } from '../../../shared/ui/data-filter/data-filter.component';

/** How a contract is billed: the stored value, and the words the contract forms use. */
export const CONTRACT_BILLING_METHOD_LABELS: Readonly<Record<string, string>> = {
  PerService: 'Per Service',
  FlatMonthly: 'Flat Monthly',
};

/**
 * The self-service changes a contract can allow: the stored value, and the
 * words the contract forms use. One list, so the table that shows them and
 * the dialog that sets them cannot drift into naming them differently.
 */
export const CONTRACT_MODIFICATION_LABELS: Readonly<Record<string, string>> = {
  Skip: 'Skip pickup',
  ExtraPickup: 'Extra pickup',
  Suspend: 'Suspend service',
  ChangeAddress: 'Change address',
  ChangeDay: 'Change service day',
  ChangeFrequency: 'Change frequency',
};

/** A label map as dropdown options, in the map's own order. */
export function optionsOf(labels: Readonly<Record<string, string>>): DataFilterOption[] {
  return Object.entries(labels).map(([value, label]) => ({ value, label }));
}
